export const HASLang = {
    profile: 'پروفایل',
    learn: 'آموزش',
    support: 'پشتیبانی',
    aboutUs: 'درباره ما',
    logout: 'خروج',
    promote: 'ارتقا',
    version: 'نسخه',
    cancel: 'لغو',
    submit: 'خروج پس از ارسال پاسخ ها',
    logOutWithoutSubmit: 'خروج بدون ارسال پاسخ ها',
    logoutText1: 'در حال حاضر اکانت شما شامل',
    logoutText2:
        'پاسخ ثبت نشده است که با خروج، این اطلاعات از حافظه موقت دستگاه شما حذف خواهند شد. پیش از ارسال پاسخ از اتصال دستگاه به اینترنت اطمینان حاصل فرمایید.',
    submiting: 'در حال خروج...',
    submitErr: 'ثبت پاسخ با خطا مواجه شد. لطفا از اتصال خود به شبکه اینترنت اطمینان حاصل فرمایید',
    logoutConfirm: 'آیا اطمینان دارید که میخواهید از حساب کاربری خود خارج شوید؟',
    noInternetErr: 'برای خروج لازم است دستگاه خود را به اینترنت متصل کنید',
};
